import { createSelector } from 'reselect';
import { createFeatureSelector } from 'features/create-feature-selector';
import {
  TINT_PRICE_IN_RUB,
  TINT_SERVICE_ID_FOR_BASE_A_PAINT,
  TINT_SERVICE_ID_FOR_BASE_C_PAINT,
  TINT_SERVICE_IDS,
} from 'features/product-info/components/pdp-select-tint-color/pdp-select-tint-color.const';

const featureSelector = createFeatureSelector('relatedServices');

export const getDataFromRelatedServices = createSelector(featureSelector, (storeData) => {
  return storeData != null && 'data' in storeData ? storeData.data : null;
});

export const getRelatedServices = createSelector(getDataFromRelatedServices, (data) => {
  return data !== null && 'relatedServices' in data ? data.relatedServices : [];
});

export const areRelatedServicesLoading = createSelector(
  featureSelector,
  (storeData) => storeData?.state === 'request',
);

export const getBaseEntityIds = createSelector(getDataFromRelatedServices, (data) => {
  return data !== null && 'baseEntityIds' in data ? data.baseEntityIds : [];
});

export const getBaseEntityIdForTintService = createSelector(getBaseEntityIds, (ids) => {
  return ids.find((id) => TINT_SERVICE_IDS.includes(id)) || null;
});

export const getPriceOfTintService = createSelector(getBaseEntityIdForTintService, (baseEntityId) => {
  switch (baseEntityId) {
    case TINT_SERVICE_ID_FOR_BASE_C_PAINT: {
      return TINT_PRICE_IN_RUB.TINT_SERVICE_ID_FOR_BASE_C_PAINT;
    }
    case TINT_SERVICE_ID_FOR_BASE_A_PAINT:
    default:
      return TINT_PRICE_IN_RUB.TINT_SERVICE_ID_FOR_BASE_A_PAINT;
  }
});
